import { render, staticRenderFns } from "./ehc-main-menu-edit.vue?vue&type=template&id=6aafc7e2"
import script from "./ehc-main-menu-edit.vue?vue&type=script&lang=js"
export * from "./ehc-main-menu-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports